module.exports = __webpack_public_path__ + "static/media/useCase103x.4ca56514.png";